import { render } from "./Deleted.vue?vue&type=template&id=3b8d1052"
import script from "./Deleted.vue?vue&type=script&lang=js"
export * from "./Deleted.vue?vue&type=script&lang=js"

import "./Deleted.vue?vue&type=style&index=0&id=3b8d1052&lang=css"

import exportComponent from "/home/runner/work/vue-soft/vue-soft/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__